module.exports = function() {
  return new Worker(__webpack_public_path__ + "a1651c52fb14c45a448f.worker.js");
};